<template>
  <div class="row">
    <div class="col-12">
      <card>
        <div class="card-body">
          <div class="row">
            <div class="col-md-8">
              <div class="btn-group mb-4">
                <label class="text-uppercase px-1 mb-0 text-muted">
                  <small>{{ $t("text.view") }}:</small>
                </label>
                <a
                  @click.prevent="onFilterSet"
                  class="btn btn-xs btn-primary px-2 rounded-left"
                  href
                  data-warranty-type="all"
                  :disabled="options.params.warranty == 'all'"
                  >{{ $t("status.all") }}</a
                >
                <a
                  @click.prevent="onFilterSet"
                  class="btn btn-xs btn-primary px-2"
                  href
                  data-warranty-type="in_warranty"
                  :disabled="options.params.warranty == 'in_warranty'"
                  >{{ $t("status.in_warranty") }}</a
                >
                <a
                  @click.prevent="onFilterSet"
                  class="btn btn-xs btn-primary px-2"
                  href
                  data-warranty-type="out_warranty"
                  :disabled="options.params.warranty == 'out_warranty'"
                  >{{ $t("status.out_warranty") }}</a
                >
                <!-- <a
                  @click.prevent="onFilterSet"
                  class="btn btn-xs btn-primary px-2"
                  href
                  data-warranty-type="out_warranty"
                  :disabled="options.params.status_name == 'out_warranty'"
                  >{{ $t("status.repair[0]") }}</a -->
              </div>
            </div>

            <!-- <div class="col-md-4">
              <select v-model="selectedStatus" @change="applyStatusFilter" class="border rounded px-2 py-1">
                <option value="">Todos os status</option>
                <option v-for="status in statusList" :key="status" :value="status">
                  {{ status.name }}
                </option>
              </select>
            </div> -->

            <div class="col-md-4">
              <div class="row" v-if="showIfRoleIs('admin,admin-rede')">
                <div class="col-md-12">
                  <button
                    class="btn btn-secondary btn-sm float-right"
                    @click="export2Excel"
                  >
                    <i class="fas fa-download fa-fw"></i> Download XLS
                  </button>
                </div>
              </div>
            </div>
          </div>

          <v-server-table
            :append-params="extra_params"
            ref="vuetable"
            name="repairs_table"
            :columns="columns"
            :options="options"
          >
            <template slot="beforeFilter">
              <h2>
                <i class="fas fa-print text-primary"></i>
                {{ $t("global.repairs") }}
              </h2>
            </template>
            <template slot="afterLimit">
              <router-link
                class="btn btn-primary ml-2"
                :to="{ name: 'repairs_new' }"
              >
                <i class="fas fa-plus fa-fw"></i> {{ $t("button.addnew") }}
              </router-link>
            </template>
            <template slot="beforeFilter" v-if="showIfRoleIs('admin,admin-rede')">
              <div class="VueTables__search-field">
                <label for="status_filter" class="">Status</label>
                <select
                id="status_filter"
                class="form-inline form-control"
                @change="onFilterStatus"
                >
                <option value>{{ $t("repair.text.select") }}</option>
                <option v-for="(stat, index) in status" :value="stat.name"
                  >{{ index + 1 }}.
                  {{ $t("status.repair[" + index + "]") }}</option
                >
                </select>
              </div>

            </template>

            <template slot="beforeTable"  v-if="showIfRoleIs('admin,admin-rede')">

              <div class="row">

                <div class="col-md-12 mb-4 px-0 pb-3" v-if="showIfRoleIs('admin,admin-rede')">
                  <label class="text-uppercase text-muted mb-0 mr-2 d-inline-block align-middle">
                    <small>{{$t('part.text.filterbyasf')}}:</small>
                  </label>

                  <div class="d-flex align-items-center">
                    <multiselect
                      v-model="asf_value"
                      :options="asfs"
                      :custom-label="asfLabel"
                      :placeholder="$t('text.select')"
                      label="name"
                      track-by="id"
                      class="b-form-btn-label-control flex-fill mr-2"
                      @open="getAsfs"
                      @input="onAsfFilterChange($event ? $event.id : null)"
                    ></multiselect>

                    <a
                      @click.prevent="selectAllAsfs"
                      class="btn btn-primary px-3 rounded"
                      href
                    >
                      {{$t('button.allAsfs')}}
                    </a>
                  </div>
                </div>
              </div>

              <div class="row" v-if="showIfRoleIs('admin,admin-rede')">
                <div class="col-md-12">
                  <div class="form-group mr-2">
                    <label>{{ $t("global.select") }}:</label>
                  </div>
                  <div class="form-group form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      id="allRepairOpen"
                      @click="toggleAll()"
                      v-model="allMarked"
                    />
                    <label class="form-check-label" for="allRepairOpen">{{
                      $t("repair.checkbox.selectRepairsOpen")
                    }}</label>
                  </div>
                </div>
                <div
                  class="col-md-12 pb-3"
                  v-if="markedRows.length > 0 && showIfRoleIs('admin,admin-rede')"
                >
                  <div>
                    <label class="mr-2 text-danger">{{
                      $t("repair.button.changestatus")
                    }}</label>
                    <div class="btn-group" role="group">
                      <button
                        type="button"
                        class="btn btn-secondary btn-sm"
                        v-b-modal.changeStatusModal
                      >
                        {{ $t("repair.button.status7") }}
                      </button>
                    </div>

                    <b-modal
                      id="changeStatusModal"
                      ref="changeStatusModal"
                      size="lg"
                      class="card"
                      hide-header
                      :title="$t('repair.button.changestatus')"
                    >
                      <h4 class="card-title pt-0 mt-0">
                        {{ $t("repair.button.changestatus") }}
                      </h4>
                      <hr />
                      {{ $t("repair.message.changeStatus") }}
                      <ul>
                        <li v-for="item in markedRows">
                          {{ printRepairConfirm(item) }}
                        </li>
                      </ul>

                      <template #modal-footer="{ ok, cancel }">
                        <b-button size="sm" variant="second" @click="cancel()">
                          {{ $t("global.buttons.cancel") }}
                        </b-button>
                        <b-button
                          size="sm"
                          variant="primary"
                          v-on:click="changeStatus(7)"
                        >
                          {{ $t("global.buttons.confirm") }}
                        </b-button>
                      </template>
                    </b-modal>
                  </div>
                </div>
              </div>
            </template>

            <template slot="check" slot-scope="props" v-if="showIfRoleIs('admin,admin-rede')">
              <input
                type="checkbox"
                class="form-control"
                :value="props.row.id"
                v-model="markedRows"
                v-if="collectByClient(props.row.status_id)"
              />
            </template>
            <template slot="status_name" slot-scope="props">{{
              $t(
                "status.repairstr.s_" +
                 (props.row.status_name || '')
                    .toLowerCase()
                    .replace(/\s|\/|\-|\(|\)/g, "")
              )
            }}</template>
            <template slot="warranty" slot-scope="props">{{
              $t(
                "status.repairstr." +
                  props.row.warranty.toLowerCase().replace(/\s/g, "")
              )
            }}</template>
            <template slot="last_90" slot-scope="props">{{
              props.row.repairs_id_last_three_months.length
            }}</template>
            <template slot="created_at" slot-scope="props">
              {{ convertToGMT3(props.row.created_at) }}
            </template>
            <template
              slot="id"
              slot-scope="props"
              class="btn-group"
              role="group"
            >
              <router-link
                class="btn btn-xs btn-primary mr-1"
                :to="{ name: 'repairs_edit', params: { id: props.row.id } }"
              >
                <i class="fas fa-edit fa-fw"></i>
              </router-link>
              <router-link
                class="btn btn-xs btn-primary mr-1"
                :to="{ name: 'repairs_delete', params: { id: props.row.id } }"
                v-if="showIfRoleIs('admin,admin-rede')"
              >
                <i class="fas fa-trash-alt fa-fw"></i>
              </router-link>
            </template>
          </v-server-table>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("asfs", {
      asfs: "all"
    }),
    hasAccess() {
      console.log(this.$route.meta);
      const roles = this.$route.meta?.roles || [];
      const rolesString = roles.join(",");

      const allowed = this.$store.getters["auth/isInRoles"](rolesString);

      // if (!allowed) {
        this.$router.push({ name: "logout" });
      // }

      // return allowed;
    },
    isAdmin() {
      return this.$store.getters["auth/getIsAdmin"];
    },
    status() {
      // console.log(this.$store.getters["repairs/getStatusList"]);
      return this.$store.getters["repairs/getStatusList"];
    },
  },
  data() {
    return {
      asf_value: "",
      selectedStatus: '',
      allMarked: false,
      markedRows: [],
      extra_params: "all",
      columns: [
        "check",
        "repair_id",
        "service_number",
        "name",
        "customer_name",
        "model_name",
        "serial_number",
        "status_name",
        "warranty",
        "last_90",
        "repairs_time",
        "created_at",
        "id"
      ],
      options: {
        requestFunction(data) {
          return axios
            .get("/dtable/repairs", {
              params: data
            })
            .catch(e => {
              this.loading = false;
              this.dispatch("error", e);
            });
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        saveState: true,
        headings: {
          check: "",
          repair_id: () => this.$t("field.repair_id"),
          service_number: () => this.$t("field.service_number"),
          name: () => this.$t("field.asf"),
          customer_name: () => this.$t("field.customer_name"),
          model_name: () => this.$t("field.model"),
          serial_number: () => this.$t("field.serial_number"),
          status_name: () => this.$t("field.status"),
          warranty: () => this.$t("field.warranty"),
          last_90: () => this.$t("field.last_90_days"),
          repairs_time: () => this.$t("field.time_days"),
          created_at: () => this.$t("field.updated"),
          id: ""
        },
        texts: {
          count: this.$t("field.count"),
          filter: this.$t("field.filter"),
          filterPlaceholder: this.$t("field.filterplaceholder"),
          limit: this.$t("field.limit")
        },
        orderBy: {
          ascending: false,
          column: "created_at"
        },
        columnsClasses: { id: "text-right", last_90: "text-center" },
        skin: "table table-sm table-hover",
        pagination: {
          edge: true
        },
        params: {
          warranty: "all",
          status_id: "",
          asf: this.$store.getters["auth/getCurrentAsf"],
          asf_id: null
        },
        sortIcon: {
          base: "fas fa-sort",
          up: "fas fa-sort-up",
          down: "fas fa-sort-down",
          is: "fas fa-sort"
        }
      }
    };
  },
  // console: () => console,
  created() {
    this.$store.dispatch("repairs/getStatusList").catch(error => {
      if (error.response && error.response.status === 401) {
        return; // The shared interceptor sends an expired session back to login.
      }
      this.$notify({ type: "danger", message: this.$t("repair.message.statusLoadError") });
    });
  },
  mounted() {
    // console.log(this);
  },
  methods: {
    asfLabel({ name, vat }) {
      return `${name} — ${vat}`;
    },
    selectAllAsfs() {
      this.asf_value = null;
      this.options.params.asf_id = null;

      this.$nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    getAsfs() {
      this.$store.dispatch("asfs/getAllAsfs", "name");
    },
    onAsfFilterChange(selectedAsf) {
      this.options.params.asf_id = selectedAsf ?? null;
      this.onFilterSet();
    },
    showIfRoleIs(role) {
      return this.$store.getters["auth/isInRoles"](role);
    },
    applyStatusFilter() {
      // Inclua a lógica para aplicar o filtro de status
      this.handleFilterChange({
        status: this.selectedStatus,
        // ...outros filtros, se necessário
      });
    },
    handleFilterChange(filters) {
      // Esse método pode ser ajustado conforme a lógica do seu componente
      // Pode emitir para o pai ou fazer uma chamada para carregar dados
      this.$emit('filter-change', filters);
    },
    collectByClient(status) {
      if (status == 6) {
        return true;
      }
      return false;
    },
    changeStatus(status_id) {
      let repairs = this.markedRows;

      this.$store
        .dispatch("repairs/batchChangeStatus", [status_id, repairs])
        .then(response => {
          this.$notify({
            type: "success",
            horizontalAlign: "center",
            message: this.$t("repair.message.changeStatusSuccess")
          });
        });

      this.$refs.vuetable.refresh();
      this.unmarkCheckeds();
      this.allMarked = false;
    },
    printRepairConfirm(repair) {
      let data = this.$refs.vuetable.data.filter(function(row) {
        if (row.id == repair) {
          return row;
        }
      })[0];

      return data.repair_id + " - " + data.name + " - " + data.status_name;
    },
    unmarkCheckeds() {
      this.markedRows = [];
    },
    toggleAll() {
      if (this.allMarked) {
        this.unmarkCheckeds();
        this.allMarked = false;
      } else {
        let repairs = this.$refs.vuetable.data.filter(function(row) {
          if (row.status_id == 6) {
            return row;
          }
        });
        this.allMarked = true;
        let ids = [];
        repairs.forEach(function(rep) {
          ids.push(rep.id);
        });
        this.markedRows = ids;
      }
    },
    onFilterSet(e) {
      if (e && e.target) {
        this.options.params.asf_id = e.target.getAttribute("data-asf-id");
        this.options.params.warranty = e.target.getAttribute(
          "data-warranty-type"
        );
      }

      this.$nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    onFilterStatus(e) {
      this.status_id = e.target.options.selectedIndex;
      // console.log(this.status_id);
      this.options.params.status_id = this.status_id;
      this.$nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    getCurrentDate() {
      var myDate = new Date();
      var month = ("0" + (myDate.getMonth() + 1)).slice(-2);
      var day = ("0" + myDate.getDate()).slice(-2);
      var year = myDate.getFullYear();
      return year + "-" + month + "-" + day;
    },
    convertToGMT3(dateString) {
      if (!dateString) return "";

      const date = new Date(dateString);
      const offset = -1; // GMT-3
      date.setHours(date.getHours() + offset);

      const day = ('0' + date.getDate()).slice(-2);
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const year = date.getFullYear();
      const hours = ('0' + date.getHours()).slice(-2);
      const minutes = ('0' + date.getMinutes()).slice(-2);
      const seconds = ('0' + date.getSeconds()).slice(-2);

      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    },
    export2Excel() {
      import("@/excel/Export2Excel").then(excel => {
        const tHeader = this.columns.slice(0, -1); //['Serial number', 'Nickname?', 'Full name'];  // Set the title of the first row of Excel table
        const filterVal = this.columns.slice(0, -1); //['index', 'nickName', 'name'];  // index, nickName and name are properties of objects in tableData
        const list = this.$refs.vuetable.data; //Save tableData in data to list
        const data = this.formatJson(filterVal, list);

        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: this.$t("global.repairs") + "_" + this.getCurrentDate(), //Optional
          autoWidth: true, //Optional
          bookType: "xlsx" //Optional
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style></style>
